export default __webpack_public_path__ + "static/gitkraken_repo_main_light-a95c5847801c3a62c7a3e1060f26c813.png";